<script setup lang="ts">
import ShiftPresetDetailDialogContent from './ShiftPresetDetailDialogContent.vue'

import { useShiftPresetDetailDialog } from '../../composables/useShiftPresetDetailDialog'

import { SiteID } from '../../../sites/models/site'

const { siteId } = defineProps<{
  siteId: SiteID
}>()

const { hide, isShown, shiftPreset } = useShiftPresetDetailDialog()
</script>

<template>
  <Dialog
    :visible="isShown"
    header="Shift Preset Details"
    dismissable-mask
    modal
    class="w-full max-w-xl md:w-1/2"
    @update:visible="hide"
  >
    <ShiftPresetDetailDialogContent
      v-if="shiftPreset"
      :site-id="siteId"
      :shift-preset="shiftPreset"
    />
  </Dialog>
</template>
